<template>
    <section class="app-main">
        <transition name="fade-transform" mode="out-in">
            <router-view :key="key"></router-view>
        </transition>
    </section>
</template>

<script>
	export default {
		name: 'AppMain',
		computed: {
			key() {
				return this.$route.fullPath
			}
		}
	}
</script>

<style scoped>
    .app-main {
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue